import { SVGProps } from 'react';
const SvgBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 4H7a1 1 0 0 0-1 1v15.131a1 1 0 0 0 1.555.832l3.89-2.593a1 1 0 0 1 1.11 0l3.89 2.593A1 1 0 0 0 18 20.131V5a1 1 0 0 0-1-1Z"
    />
  </svg>
);
export default SvgBookmark;
